import {Injectable} from "@angular/core";
import {UserMarketingRulesRepository} from "@app/core/user-marketing-rules/domain/user-marketing-rules-repository";
import {UserMarketingRules} from "@app/core/user-marketing-rules/domain/user-marketing-rules";
import {UserMarketingRulesDao} from "@app/core/user-marketing-rules/infrastructure/user-marketing-rules-dao";
import {UserMarketingRulesDbMapper} from "@app/core/user-marketing-rules/infrastructure/user-marketing-rules-db-mapper";
import {Observable} from "rxjs";

@Injectable()
export class UserMarketingRulesDataRepository implements UserMarketingRulesRepository {

    constructor(
        private dao: UserMarketingRulesDao,
        private mapper: UserMarketingRulesDbMapper,
    ) {}

    search(): Observable<UserMarketingRules | null> {
        return new Observable(subscriber => {
            const userMarketingRulesDb = this.dao.search();
            if (userMarketingRulesDb == null) {
                subscriber.next(null);
                subscriber.complete();
                return;
            }
            const userMarketingRules = this.mapper.toEntity(userMarketingRulesDb);
            subscriber.next(userMarketingRules);
            subscriber.complete();
        });
    }

    update(userData: UserMarketingRules): Observable<void> {
        return new Observable(subscriber => {
            const userMarketingRulesDb = this.mapper.fromEntity(userData);
            this.dao.update(userMarketingRulesDb);
            subscriber.next(undefined);
            subscriber.complete();
        });
    }

}